import { c as _c } from "react/compiler-runtime";
import { CloseIcon, SaveIcon } from '@systemeio/ui/icons';
import { CurrencyEnum, FormInput, Hint, PrimaryButton, toast } from '@systemeio/ui';
import { BadRequest, InternalError } from '@systemeio/util';
import { useUserPricePlans } from 'modules/digital-product/price-plans/hooks/use-user-price-plans';
import { PricePlanEditInterface } from 'modules/digital-product/price-plans/types/price-plan-interface';
import React, { useEffect, useState } from 'react';
import { FieldErrorAndDescription } from 'shared/components/form/field-error-and-description';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { PricePlanType } from '@systemeio/types';
interface EditPricePlanFormProps {
  onEditPricePlan: (value: PricePlanEditInterface) => Promise<void>;
  closeForm: () => void;
  editPricePlanErrors: PricePlanEditInterface;
  pricePlanId?: PricePlanType['id'];
  currency: CurrencyEnum;
}
const defaultValues: PricePlanEditInterface = {
  name: '',
  innerName: '',
  statementDescriptor: ''
};
function EditPricePlanForm(t0) {
  const $ = _c(62);
  const {
    onEditPricePlan,
    closeForm,
    editPricePlanErrors,
    pricePlanId,
    currency
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [tempState, setTempState] = useState(defaultValues);
  const [isFetching, setIsFetching] = useState(false);
  const [error, setError] = useState("");
  const {
    userPricePlans
  } = useUserPricePlans(currency);
  let t1;
  if ($[0] !== closeForm || $[1] !== onEditPricePlan || $[2] !== t || $[3] !== tempState) {
    t1 = async () => {
      ;
      try {
        setError("");
        setIsFetching(true);
        await onEditPricePlan(tempState);
        setIsFetching(false);
        closeForm();
      } catch (t2) {
        const e = t2;
        setIsFetching(false);
        if (e instanceof BadRequest) {
          if (e.errors.common) {
            setError(e.errors.common.join(""));
          }
        } else {
          if (e instanceof InternalError) {
            setError(t("core.error.internal_error_message"));
          } else {
            toast.error(t("global.error"));
          }
        }
      }
    };
    $[0] = closeForm;
    $[1] = onEditPricePlan;
    $[2] = t;
    $[3] = tempState;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleConfirm = t1;
  let t2;
  let t3;
  if ($[5] !== pricePlanId || $[6] !== userPricePlans) {
    t2 = () => {
      const pricePlan_0 = userPricePlans?.find(pricePlan => pricePlan.id === pricePlanId);
      if (pricePlan_0) {
        setTempState(prev => ({
          ...prev,
          name: pricePlan_0.name,
          innerName: pricePlan_0.innerName,
          statementDescriptor: pricePlan_0.statementDescriptor
        }));
      }
    };
    t3 = [pricePlanId, userPricePlans];
    $[5] = pricePlanId;
    $[6] = userPricePlans;
    $[7] = t2;
    $[8] = t3;
  } else {
    t2 = $[7];
    t3 = $[8];
  }
  useEffect(t2, t3);
  const t4 = `cursor-pointer ${isFetching && "fill-text-secondary pointer-events-none"} absolute right-1 top-1 lg:right-2 lg:top-2`;
  let t5;
  if ($[9] !== closeForm) {
    t5 = () => closeForm();
    $[9] = closeForm;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <CloseIcon className={t4} onClick={t5} />;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const t7 = !pricePlanId;
  let t8;
  if ($[14] !== t) {
    t8 = t("dashboard.funnel.configuration.common.price_plan.name_label");
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = e_0 => setTempState(prev_0 => ({
      ...prev_0,
      name: e_0.target.value
    }));
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== editPricePlanErrors.name || $[18] !== t7 || $[19] !== t8 || $[20] !== tempState.name) {
    t10 = <FormInput required={true} isPreFetching={t7} label={t8} labelClassName="lg:text-[15px] text-sm text-text-primary font-medium" value={tempState.name} onChange={t9} maxLength={256} error={editPricePlanErrors.name} />;
    $[17] = editPricePlanErrors.name;
    $[18] = t7;
    $[19] = t8;
    $[20] = tempState.name;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  const t11 = !pricePlanId;
  let t12;
  if ($[22] !== t) {
    t12 = t("dashboard.funnel.configuration.common.price_plan.inner_name_label");
    $[22] = t;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = e_1 => setTempState(prev_1 => ({
      ...prev_1,
      innerName: e_1.target.value
    }));
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== editPricePlanErrors.innerName || $[26] !== t11 || $[27] !== t12 || $[28] !== tempState.innerName) {
    t14 = <FormInput required={true} isPreFetching={t11} label={t12} labelClassName="lg:text-[15px] text-sm text-text-primary font-medium" value={tempState.innerName} onChange={t13} maxLength={256} error={editPricePlanErrors.innerName} />;
    $[25] = editPricePlanErrors.innerName;
    $[26] = t11;
    $[27] = t12;
    $[28] = tempState.innerName;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  const t15 = !pricePlanId;
  let t16;
  if ($[30] !== t) {
    t16 = t("dashboard.funnel.configuration.common.price_plan.statement_descriptor_popover");
    $[30] = t;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t) {
    t17 = t("dashboard.funnel.configuration.common.price_plan.statement_descriptor");
    $[32] = t;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== t16 || $[35] !== t17) {
    t18 = <Hint label={t16}>{t17}</Hint>;
    $[34] = t16;
    $[35] = t17;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = e_2 => setTempState(prev_2 => ({
      ...prev_2,
      statementDescriptor: e_2.target.value
    }));
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== editPricePlanErrors.statementDescriptor || $[39] !== t15 || $[40] !== t18 || $[41] !== tempState.statementDescriptor) {
    t20 = <FormInput required={true} isPreFetching={t15} label={t18} labelClassName="lg:text-[15px] text-sm text-text-primary font-medium" value={tempState.statementDescriptor} onChange={t19} maxLength={256} error={editPricePlanErrors.statementDescriptor} />;
    $[38] = editPricePlanErrors.statementDescriptor;
    $[39] = t15;
    $[40] = t18;
    $[41] = tempState.statementDescriptor;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  const t21 = !tempState.name || !tempState.innerName || !tempState.statementDescriptor;
  let t22;
  if ($[43] !== handleConfirm) {
    t22 = e_3 => {
      e_3.preventDefault();
      handleConfirm();
    };
    $[43] = handleConfirm;
    $[44] = t22;
  } else {
    t22 = $[44];
  }
  let t23;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <SaveIcon />;
    $[45] = t23;
  } else {
    t23 = $[45];
  }
  let t24;
  if ($[46] !== t) {
    t24 = t("global.save");
    $[46] = t;
    $[47] = t24;
  } else {
    t24 = $[47];
  }
  let t25;
  if ($[48] !== isFetching || $[49] !== t21 || $[50] !== t22 || $[51] !== t24) {
    t25 = <div className="flex "><PrimaryButton disabled={t21} width="large" onClick={t22} isFetching={isFetching} type="submit">{t23}{t24}</PrimaryButton></div>;
    $[48] = isFetching;
    $[49] = t21;
    $[50] = t22;
    $[51] = t24;
    $[52] = t25;
  } else {
    t25 = $[52];
  }
  let t26;
  if ($[53] !== error) {
    t26 = <FieldErrorAndDescription error={error} errorClassName="text-center mt-2" />;
    $[53] = error;
    $[54] = t26;
  } else {
    t26 = $[54];
  }
  let t27;
  if ($[55] !== t10 || $[56] !== t14 || $[57] !== t20 || $[58] !== t25 || $[59] !== t26 || $[60] !== t6) {
    t27 = <div className="border-text-secondary/30 relative flex flex-col gap-5 rounded-lg border px-5 py-3">{t6}{t10}{t14}{t20}{t25}{t26}</div>;
    $[55] = t10;
    $[56] = t14;
    $[57] = t20;
    $[58] = t25;
    $[59] = t26;
    $[60] = t6;
    $[61] = t27;
  } else {
    t27 = $[61];
  }
  return t27;
}
export default EditPricePlanForm;